import axios from 'axios';
import apiService from '@/core/common/services/api.service';
import { odataErrorHandler } from '@/core/common/services/error-handler.service';

// In dieser Funktion werden die Restriktionen für einen Zeitraum und die gewählten Filter geladen
// laender und reisen werden jeweils als wiederholte Query-Parameter (?land=DE&land=FR) übergeben
// von und bis sind Pflichtparameter im Format YYYY-MM-DD
export async function getRestriktionskonfiguration({ von, bis, laender = [], reisen = [], signal }) {
  const params = new URLSearchParams();
  params.set('von', von);
  params.set('bis', bis);
  laender.forEach(code => params.append('land', code));
  reisen.forEach(kuerzel => params.append('reise', kuerzel));

  return apiService
    .get('Restriktionskonfiguration', `?${params.toString()}`, { signal })
    .then(res => (res.data && res.data.result ? res.data.result : null))
    .catch(error => {
      // Abgebrochene Requests (AbortController) sind gewollt und lösen keine Fehleranzeige aus
      if (axios.isCancel(error)) {
        return null;
      }
      return odataErrorHandler(error);
    });
}

// In dieser Funktion wird eine Restriktionskonfiguration (Sperrzeit) gespeichert
// Ein gesetztes payload.id kennzeichnet eine bestehende Konfiguration und führt zu einem PUT, sonst POST
export async function saveRestriktionskonfiguration(payload) {
  const request = payload.id
    ? apiService.put('Restriktionskonfiguration', payload)
    : apiService.post('Restriktionskonfiguration', payload);

  return request
    .then(res => res.data)
    .catch(error => {
      odataErrorHandler(error);
      return Promise.reject(error);
    });
}

// In dieser Funktion wird eine einzelne Restriktion an einem bestimmten Tag gelöscht
export async function deleteRestriktionTag({ id, datum }) {
  return apiService
    .delete(`/Restriktionskonfiguration/${id}/restriktion/${datum}`)
    .then(res => res.data)
    .catch(odataErrorHandler);
}

// In dieser Funktion wird eine komplette Serie (Restriktionskonfiguration) gelöscht
export async function deleteRestriktionSerie({ id }) {
  return apiService
    .delete(`/Restriktionskonfiguration/${id}`)
    .then(res => res.data)
    .catch(odataErrorHandler);
}
